/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./previewer.vue?vue&type=template&id=52f88670&scoped=true&"
import script from "./previewer.vue?vue&type=script&lang=js&"
export * from "./previewer.vue?vue&type=script&lang=js&"
import style0 from "./previewer.vue?vue&type=style&index=0&id=52f88670&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f88670",
  null
  
)

export default component.exports